import filter from '@/api/filter';
export const config = {
  data() {
    return {
      columns: []
    };
  },
  methods: {
    getColumns() {
      let columns = [];
      // 待发放
      if (this.tableItem.okbStatus == '-2' && this.$units.pointAction('offline_81_7_btn6')) {
        columns.push({
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        });
      }
      columns = columns.concat([
        {
          title: '结算周期',
          key: 'settlementDate',
          align: 'center',
          minWidth: 140,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '结算单名称',
          key: 'reportName',
          align: 'center',
          minWidth: 150
        }
      ]);
      if (['-1', '9', '1'].includes(this.searchParams.okbStatus)) {
        columns = columns.concat([
          {
            title: '发票',
            slot: 'detail',
            width: '120',
            align: 'center'
          }
        ]);
      }
      if (this.tableItem.okbStatus != '-2') {
        columns = columns.concat([
          {
            title: '提现类型',
            align: 'center',
            render(h, params) {
              let withdrawType = params.row.withdrawType;
              return <span>{withdrawType == 2 ? '支付宝' : '银行卡'}</span>;
            },
            minWidth: 150
          }
        ]);
      }
      columns = columns.concat([
        {
          title: '税前合计（元）',
          key: 'totalIncome',
          align: 'center',
          minWidth: 170,
          render(h, params) {
            const text = params.row.issueType == 3 ? params.row.requestAmount : params.row.totalIncome;
            return <span>{text || '-'}</span>;
          }
        },
        {
          title: '税后合计（元）',
          key: 'netIncome',
          align: 'center',
          minWidth: 140,
          render(h, params) {
            const text = params.row.issueType == 3 ? params.row.requestAmount : params.row.netIncome;
            return <span>{text || '-'}</span>;
          }
        }
      ]);
      if (this.tableItem.okbStatus == 99) {
        columns.push({
          title: '风险单金额（元）',
          key: 'riskAmount',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            return <span>{params.row.riskAmount || '0'}</span>;
          }
        });
      }
      // 非待发放
      if (this.tableItem.okbStatus != -2) {
        columns.push({
          title: '发放时间',
          key: 'createTime',
          align: 'center',
          minWidth: 140,
          render(h, params) {
            let createTime = params.row.createTime;
            return <span>{filter.filterTime(createTime, 'YYYY-MM-DD')}</span>;
          }
        });
      }

      if (this.tableItem.okbStatus == 1) {
        columns = columns.concat([
          {
            title: '打款时间',
            key: 'paymentTime',
            align: 'center',
            minWidth: 140,
            render(h, params) {
              let paymentTime = params.row.paymentTime;
              return <span>{filter.filterTime(paymentTime, 'YYYY-MM-DD')}</span>;
            }
          },
          {
            title: '打款账户',
            key: 'accountName',
            minWidth: 240,
            align: 'center'
          },
          {
            title: '交易流水号',
            key: 'batchNo',
            align: 'center',
            minWidth: 140
          }
        ]);
      }
      // 提现成功/提现失败/驳回
      if ([-1, 2].includes(this.tableItem.okbStatus * 1)) {
        columns = columns.concat([
          {
            title: '申请打款时间',
            key: 'requestTime',
            align: 'center',
            minWidth: 140,
            render(h, params) {
              let requestTime = params.row.requestTime;
              return <span>{filter.filterTime(requestTime, 'YYYY-MM-DD')}</span>;
            }
          },
          {
            title: '交易流水号',
            key: 'batchNo',
            align: 'center',
            minWidth: 140
          }
        ]);
      }
      columns.push({
        title: '操作',
        slot: 'action',
        fixed: 'right',
        width: 80,
        align: 'center'
      });
      this.columns = columns;
    }
  }
};
